import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private readonly http = inject(HttpClient);
  private readonly platformId = inject(PLATFORM_ID);
  private config: any = {};

  loadConfig(): Promise<void> {
    // config.json is written at container runtime (start-nginx.sh) and read in the
    // browser. During server-side prerender (SSG) there is no such file and the HTTP
    // call would hang the build's stability wait — skip it and use defaults.
    if (!isPlatformBrowser(this.platformId)) return Promise.resolve();

    return this.http
      .get('/assets/config.json')
      .toPromise()
      .then((config) => {
        this.config = config;
      })
      .catch(() => {
        this.config = {};
      }); // fallback if not found
  }

  get(key: string): any {
    return this.config[key];
  }
}
